import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { update } from 'lodash';
import { i18n } from '../../translate/i18n';

const initialState = {
  actions: { count: 0, rows: [] },
  actionsFilter: {},
  // Filters
  filteredUsers: [],
  filteredEquipments: [],
  filteredPlaces: [],
  filteredAreas: [],
  filteredStatus: [
    { value: 'progress', label:  i18n.t('statusActionModalFilter.progress') },
    { value: 'overdue', label: i18n.t('statusActionModalFilter.overdue') }
  ],
  filteredCompanies: [],
  companiesForFilters: [],
  loadingCompanies: false,
  startDate: null,
  endDate: null,
  action: {},
  loading: false,
  checkDelete: {},
  maxAccountablesAllowed: 5,
  completeActionFiles: [],
};


const requestActionsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchActionsSuccess = (state, action) => {
  return updateObject(state, {
    actions: action.actions,
    loading: false
  });
};

const getUserAction = (state, action) => {
  return updateObject(state, { filteredUsers: [{ value: action.id, label: action.name }] });
};

const setActionsFilter = (state, action) => {
  return updateObject(state, {
    actionsFilter: action.actionsFilter,
  });
};

const fetchActionByIdSuccess = (state, action) => {
  return updateObject(state, {
    action: action.action,
    loading: false
  });
}

const requestActionsFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteActionsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteActionsSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateActionsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postActionsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const filterActionUsers = (state, action) => {
  return updateObject(state, { filteredUsers: action.users });
}

const filterActionUsersRemove = (state, action) => {
	let arr = [...state.filteredUsers];
	const filteredUsers = arr.filter(user => user.value !== action.user.value)
  return updateObject(state, { filteredUsers });
}

const filterActionUserStateRemove = (state, action) => {
	return updateObject(state, { filteredUsers: [] });
}

const filterActionEquipments = (state, action) => {
  return updateObject(state, { filteredEquipments: action.equipments });
}

const filterActionEquipmentsRemove = (state, action) => {
	let arr = [...state.filteredEquipments];
	const filteredEquipments = arr.filter(equipment => equipment.value !== action.equipment.value)
  return updateObject(state, { filteredEquipments });
}

const filterActionPlaces = (state, action) => {
  return updateObject(state, { filteredPlaces: action.places });
}

const filterActionPlacesRemove = (state, action) => {
	let arr = [...state.filteredPlaces];
	const filteredPlaces = arr.filter(place => place.value !== action.place.value)
  return updateObject(state, { filteredPlaces });
}

const filterActionAreas = (state, action) => {
  return updateObject(state, { filteredAreas: action.areas });
}

const filterActionAreasRemove = (state, action) => {
	let arr = [...state.filteredAreas];
	const filteredAreas = arr.filter(area => area.value !== action.area.value)
  return updateObject(state, { filteredAreas });
}

const filterActionStatus = (state, action) => {
  return updateObject(state, { filteredStatus: action.status });
}

const filterActionStatusRemove = (state, action) => {
	let arr = [...state.filteredStatus];
	const filteredStatus = arr.filter(status => status.value !== action.status.value)
  return updateObject(state, { filteredStatus });
}

const filterActionStartDate = (state, action) => {
  let startDate = action.startDate;
  return updateObject(state, { startDate });
}

const filterActionStartDateRemove = (state, action) => {
  return updateObject(state, { startDate: null });
}

const filterActionEndDate = (state, action) => {
  let endDate = action.endDate;
  return updateObject(state, { endDate });
}

const filterActionEndDateRemove = (state, action) => {
  return updateObject(state, { endDate: null });
}

const filterActionCompanies = (state, action) => {
  return updateObject(state, { filteredCompanies: action.payload });
}

const filterActionCompaniesRemove = (state, action) => {
	let arr = [...state.filteredCompanies];
	const filteredCompanies = arr.filter(area => area.value !== action.payload)
  return updateObject(state, { filteredCompanies });
}

const filterActionClear = (state, action) => {
  return updateObject(state, {filteredCompanies: [], filteredUsers: [], filteredEquipments: [], filteredPlaces: [], filteredAreas: [], filteredStatus: [], startDate: null, endDate: null });
}

const changeActionStatusStart = (state) => {
  return updateObject(state, {loading: true});
}

const changeActionStatusSuccessFail = (state) => {
  return updateObject(state, {loading: false});
}

const addCompleteActionFile = (state, action) => {
  console.log(action.files);
  let filesCopy = [...state.completeActionFiles];
  filesCopy = [...filesCopy, ...action.files];
  return updateObject(state, {completeActionFiles: filesCopy});
}

const editCompleteActionFile = (state, action) => {
  let filesCopy = [...state.completeActionFiles];
  const fileIndex = filesCopy.findIndex((file) => file.id === action.fileId);
  filesCopy[fileIndex] = {
    ...filesCopy[fileIndex],
    ...action.file,
  };
  return updateObject(state, {completeActionFiles: filesCopy});
}
const deleteCompleteActionFile = (state, action) => {
  let filesCopy = [...state.completeActionFiles];
  const fileIndex = filesCopy.findIndex((file) => file.id === action.fileId);
  filesCopy.splice(fileIndex, 1);
  return updateObject(state, {completeActionFiles: filesCopy});
}

const clearCompleteActionsFile = (state) => {
  return updateObject(state, { completeActionFiles: [] })
}

const fetchCompaniesForFiltersStart = (state) => {
  return updateObject(state, { loadingCompanies: true })
};

const fetchCompaniesForFiltersSuccess = (state, action) => {
  return updateObject(state, { loadingCompanies: false, companiesForFilters: action.payload })
};

const fetchCompaniesForFiltersFail = (state) => {
  return updateObject(state, { loadingCompanies: false })
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_ACTIONS_START: return requestActionsStart(state, action);
    case actionTypes.FETCH_ACTIONS_SUCCESS: return fetchActionsSuccess(state, action);
    case actionTypes.FETCH_ACTIONS_BY_ID_SUCCESS: return fetchActionByIdSuccess(state, action);
    case actionTypes.REQUEST_ACTIONS_FAIL: return requestActionsFail(state, action);
    case actionTypes.DELETE_ACTIONS_SUCCESS: return deleteActionsSuccess(state, action);
    case actionTypes.CHECK_DELETE_ACTIONS_SUCCESS: return checkDeleteActionsSuccess(state, action);
    case actionTypes.UPDATE_ACTIONS_SUCCESS: return updateActionsSuccess(state, action);
    case actionTypes.POST_ACTIONS_SUCCESS: return postActionsSuccess(state, action);
    case actionTypes.ACTIONS_CHANGE_STATUS_START: return changeActionStatusStart(state);
    case actionTypes.ACTIONS_CHANGE_STATUS_SUCCESS: return changeActionStatusSuccessFail(state);
    case actionTypes.ACTIONS_CHANGE_STATUS_FAIL: return changeActionStatusSuccessFail(state);
    case actionTypes.ACTIONS_ADD_COMPLETE_ACTION_FILE: return addCompleteActionFile(state, action);
    case actionTypes.ACTIONS_EDIT_COMPLETE_ACTION_FILE: return editCompleteActionFile(state, action);
    case actionTypes.ACTIONS_DELETE_COMPLETE_ACTION_FILE: return deleteCompleteActionFile(state, action);
    case actionTypes.ACTIONS_CLEAR_COMPLETE_ACTION_FILES: return clearCompleteActionsFile(state);
    case actionTypes.ACTIONS_FETCH_COMPANIES_FOR_FILTERS_START: return fetchCompaniesForFiltersStart(state);
    case actionTypes.ACTIONS_FETCH_COMPANIES_FOR_FILTERS_SUCCESS: return fetchCompaniesForFiltersSuccess(state, action);
    case actionTypes.ACTIONS_FETCH_COMPANIES_FOR_FILTERS_FAIL: return fetchCompaniesForFiltersFail(state);

    // Filters
    case actionTypes.GET_USER: return getUserAction(state, action);
    case actionTypes.SET_ACTIONS_FILTER: return setActionsFilter(state, action);
    case actionTypes.FILTER_ACTION_USERS: return filterActionUsers(state, action);
    case actionTypes.FILTER_ACTION_USERS_REMOVE: return filterActionUsersRemove(state, action);
    case actionTypes.FILTER_ACTION_USERS_REMOVE_STATE: return filterActionUserStateRemove(state, action);
    case actionTypes.FILTER_ACTION_EQUIPMENTS: return filterActionEquipments(state, action);
    case actionTypes.FILTER_ACTION_EQUIPMENTS_REMOVE: return filterActionEquipmentsRemove(state, action);
    case actionTypes.FILTER_ACTION_PLACES: return filterActionPlaces(state, action);
    case actionTypes.FILTER_ACTION_PLACES_REMOVE: return filterActionPlacesRemove(state, action);
    case actionTypes.FILTER_ACTION_AREAS: return filterActionAreas(state, action);
    case actionTypes.FILTER_ACTION_AREAS_REMOVE: return filterActionAreasRemove(state, action);
    case actionTypes.FILTER_ACTION_STATUS: return filterActionStatus(state, action);
    case actionTypes.FILTER_ACTION_STATUS_REMOVE: return filterActionStatusRemove(state, action);
    case actionTypes.FILTER_ACTION_START_DATE: return filterActionStartDate(state, action);
    case actionTypes.FILTER_ACTION_START_DATE_REMOVE: return filterActionStartDateRemove(state, action);
    case actionTypes.FILTER_ACTION_END_DATE: return filterActionEndDate(state, action);
    case actionTypes.FILTER_ACTION_END_DATE_REMOVE: return filterActionEndDateRemove(state, action);
    case actionTypes.FILTER_ACTION_CLEAR: return filterActionClear(state, action);
    case actionTypes.FILTER_ACTION_COMPANIES: return filterActionCompanies(state, action);
    case actionTypes.FILTER_ACTION_COMPANIES_REMOVE: return filterActionCompaniesRemove(state, action);

    default: return state;
  }
};

export default reducer;